import { cn } from "@/lib/utils";
import { refineTimezone } from "@/utils/date";
import { Thumbnail, ThumbnailFallback, ThumbnailImage, Typography } from "@backpac/monica";
import type { ReactNode } from "react";
import { Temporal } from "temporal-polyfill";

interface YoutubeShortInfoProps {
  shortTitle: string;
  shortThumbnailUrl: string;
  shortUploadDate: string;
  usedMusicTrackTitle: string;
  usedMusicTrackCoverImageUrl?: string;

  rightAddon?: ReactNode;
  className?: string;
}

export function YoutubeShortInfo({
  shortTitle,
  shortThumbnailUrl,
  shortUploadDate,
  usedMusicTrackCoverImageUrl,
  usedMusicTrackTitle,
  rightAddon,
  className,
}: YoutubeShortInfoProps) {
  return (
    <div className={cn("flex gap-4 mb-4", className)}>
      <img src={shortThumbnailUrl} alt={shortTitle} className="w-[52px] rounded-[6px] object-cover" />
      <div>
        <Typography size="sm" weight={600} color="textSecondary" className="mb-[6px]">
          {shortTitle}
        </Typography>
        <Typography size="xs" weight={400} color="textMuted" className="mb-3">
          {refineTimezone(
            Temporal.PlainDateTime.from(shortUploadDate)
              .toZonedDateTime("America/Los_Angeles")
              .toLocaleString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                timeZoneName: "long",
              }),
          )}
        </Typography>
        <div className="flex gap-3">
          <Thumbnail variant="square" className="size-8">
            <ThumbnailImage src={usedMusicTrackCoverImageUrl} alt={usedMusicTrackTitle} />
            <ThumbnailFallback className="bg-backgroundDark" />
          </Thumbnail>
          <Typography size="xs" weight={500}>
            {usedMusicTrackTitle}
          </Typography>
        </div>
      </div>
      {rightAddon}
    </div>
  );
}
